import { lazy } from 'react';

// project imports
import Loadable from 'shared/components/ui-component/Loadable';
import MinimalLayout from 'shared/components/layout/MinimalLayout';
import { APPLICATION_ROUTES } from 'constants/routes';

/**
 * Represents a lazy-loaded loaded page component for Login page.
 */
const LoginPage = Loadable(lazy(() => import('pages/views/authentication/authentication2/Login2')));
/**
 * Represents a lazy-loaded component for the Google login callback page.
 * This component is loaded using Loadable and lazy loading to efficiently import
 * the Google Login Callback page as needed.
 */
const GoogleLoginCallbackPage = Loadable(lazy(() => import('pages/views/authentication/authentication2/GoogleLoginCallback')));

/**
 * Application auth routes list
 */
const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: APPLICATION_ROUTES.auth.login,
            element: <LoginPage />
        },
        {
            path: APPLICATION_ROUTES.auth.googleRedirect,
            element: <GoogleLoginCallbackPage />
        }
    ]
};

export default AuthenticationRoutes;
